<script lang="ts">
    import Home from "./home-page/Home.svelte";

    // import type { DeptCalculation } from '../models/dept-calculation';

	// let results: { standardResult: DeptCalculation, surchargeResult: DeptCalculation } | undefined = undefined;
</script>

<Home />


